export const wishpandaPurple = "#955aff"; 
export const white= "#fff"; 